var SVG = require("svg.js");

var MapRegion = function(paper, regionModel, config) {
    var self = this;
    var id = regionModel.id;
    var svgGroup = SVG.get(`${id}`);

    var _onHover, _onClick;

    var tPath = SVG.get(`${id}-title`, svgGroup);

    var rPathOrigin = SVG.get(`${id}-region`, svgGroup);

    var rPathShadow = paper.path(rPathOrigin.array());
    rPathShadow.attr({
        "cursor": "pointer",
        "fill": "transparent"
    });

    var show = () => {
        rPathOrigin.attr({
            "fill": config.fillOut,
        });
    };

    var startDrawing = (callback) => {
        var pathDrawTime = 1000;
        var opacityDrawTime = pathDrawTime/2;
        var pathDrawFPS = 25;
        var distancePerFrame = rPathShadow.length()/(pathDrawTime/1000*pathDrawFPS);

        var borderLength = 0;
        var timer = setInterval(() => {
                var pathLength = rPathOrigin.length();
                borderLength += distancePerFrame;
                rPathShadow.attr({
                    "stroke": "grey",
                    "stroke-dasharray": [borderLength, pathLength].join(" ")
                });

                if (borderLength >= pathLength) {
                    clearInterval(timer);

                    rPathShadow.animate(opacityDrawTime).attr({
                        "stroke": "none"
                    });

                    rPathOrigin.attr({
                        "opacity": "0",
                    });

                    show();

                    rPathOrigin.animate(opacityDrawTime).attr({
                        "opacity": "1",
                    });

                    if (callback) {
                        setTimeout(callback, opacityDrawTime);
                    };
                }
            },
            1000/pathDrawFPS);
    };

    this.onMouseover = (eventData) => {
        if(eventData.id === self.id) {
            tPath.attr({
                "font-weight": "bold"
            })
            rPathOrigin.attr({
                "fill": config.fillOver
            });
        }
    };

    this.onMouseout = (eventData) => {
        if(eventData.id === self.id) {
            tPath.attr({
                "font-weight": "normal"
            })
            rPathOrigin.attr({
                "fill": config.fillOut
            });
        }
    };

    this.onClick = (eventData) => { 
        if(eventData.id === self.id) {
           window.open(regionModel.link.url,  regionModel.link.target || "_self");
        }
    };

    var bindEvents = () => {
        $.pcg.frontend.eventBusService.subscribe("region/mouseover", self.onMouseover);
        $.pcg.frontend.eventBusService.subscribe("region/mouseout", self.onMouseout);
        $.pcg.frontend.eventBusService.subscribe("region/click", self.onClick);

        rPathShadow.mouseover(() => $.pcg.frontend.eventBusService.publish("region/mouseover", {
            id: self.id
        }));
        rPathShadow.mouseout(() => $.pcg.frontend.eventBusService.publish("region/mouseout", {
            id: self.id
        }));
        rPathShadow.click(() => $.pcg.frontend.eventBusService.publish("region/click", {
            id: self.id
        }));
    };

    Object.defineProperty(this, "id", {
        get: () => id
    });

    if(config.animate){
        startDrawing(bindEvents);
    } else {
        bindEvents();
    };

    Object.seal(self);

    return this;
};

module.exports = MapRegion;
